import { RequestInfo } from './vo/request-info.model';
import { MediumType } from './vo/medium-type.model';

/**
 * 表紙・特集商品選定依頼確認（担当バイヤー用）画面の値を管理するクラス
 *
 * @export KYMW7007Model
 * @class KYMW7007Model
 */
export class KYMW7007Model {
  // 受注コード
  public orderCode: string = '';

  // 一覧取得成功時の受注コード
  public displaySucceededOrderCode: string = '';

  // 企画回
  public catalogId: string = '';

  // 一覧取得成功時の企画回
  public displaySucceededCatalogId: string = '';

  // 媒体リスト
  public mediumTypeList: MediumType[] = [];

  // 媒体
  public mediumType: string = '';

  // 一覧取得成功時の媒体
  public displaySucceededMediumType: string = '';

  // 依頼一覧
  public requestInfoList: RequestInfo[] = [];

  /**
   * 計画供給高から計画供給高（千円）の変換
   * @param planSupplyBudget 
   */
  public setDispPlanSupplyBudget(planSupplyBudget: any): string {
    let retValue = 0;
    retValue = Math.round(Number(planSupplyBudget) * 0.001);
    return String(retValue);
  }
}
